<template>
	<svg
		width="30"
		height="25"
		viewBox="0 0 40 25"
		fill="currentColor"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M39.5331 11.2538C36.7743 8.08803 28.8595 0 19.996 0C11.1324 0 3.22453 8.08803 0.468048 11.2538C-0.156016 11.9643 -0.156016 13.0288 0.468048 13.7462C3.22683 16.912 11.1416 25 19.9983 25C28.8549 25 36.7766 16.912 39.5354 13.7462C40.1549 13.0288 40.1549 11.9643 39.5354 11.2538H39.5331ZM19.996 21.8273C14.8768 21.8273 10.7179 17.6409 10.7179 12.4965C10.7179 7.35212 14.8768 3.16579 19.996 3.16579C25.1151 3.16579 29.2809 7.35212 29.2809 12.4965C29.2809 17.6409 25.1151 21.8273 19.996 21.8273Z"
		/>
		<path d="M19.9983 7.83347C17.4398 7.83347 15.3558 9.92548 15.3558 12.4988C15.3558 15.0722 17.4375 17.1642 19.9983 17.1642C22.559 17.1642 24.6407 15.0722 24.6407 12.4988C24.6407 9.92548 22.559 7.83347 19.9983 7.83347Z" />
	</svg>
</template>
